export type PossibleTypesResultData = {
  possibleTypes: {
    Account: [
      "AkahuExternalAccountDetails",
      "BeneficiaryAccount",
      "ExternalBankAccountAsset",
      "FXAsset",
      "FixedIncomeFundAsset",
      "MercuryExternalAccountDetails",
      "NoticeAccountAsset",
      "QuilttExternalAccountDetails",
      "SaltEdgeExternalAccountDetails",
      "SavingsAsset",
      "SissExternalAccountDetails",
      "SkriptExternalAccountDetails",
      "StripeExternalAccountDetails",
      "TermDepositAsset",
    ];
    AccountsSummaryGroup: [
      "AccountTypeAccountsSummaryGroup",
      "AssetClassAccountsSummaryGroup",
      "BusinessEntityAccountsSummaryGroup",
      "CurrencyAccountsSummaryGroup",
      "ProviderAccountsSummaryGroup",
    ];
    ApprovalTarget: ["Payout", "Transfer"];
    Asset: [
      "ExternalBankAccountAsset",
      "FXAsset",
      "FixedIncomeFundAsset",
      "NoticeAccountAsset",
      "SavingsAsset",
      "TermDepositAsset",
    ];
    AssetRule: [
      "AlertAssetRule",
      "RecurringWithdrawalAssetRule",
      "TopUpAssetRule",
    ];
    BatchUpdateAssetResult: [
      "BatchUpdateAssetErrorResult",
      "BatchUpdateAssetSuccessResult",
    ];
    EburyTradeDetails: [
      "EburyFixedForwardDetails",
      "EburySpotTradeDetails",
      "EburyWindowForwardDetails",
    ];
    EventActor: [
      "EventActorExternalSystem",
      "EventActorExternalUser",
      "EventActorInternalUser",
      "EventActorScheduledJob",
      "EventActorStandaloneJob",
    ];
    ExternalAccountDetails: [
      "AkahuExternalAccountDetails",
      "MercuryExternalAccountDetails",
      "QuilttExternalAccountDetails",
      "SaltEdgeExternalAccountDetails",
      "SissExternalAccountDetails",
      "SkriptExternalAccountDetails",
      "StripeExternalAccountDetails",
    ];
    ExternalBankAccountDataInstitution: [
      "AkahuExternalBankAccountDataInstitution",
      "MercuryExternalBankAccountDataInstitution",
      "QuilttExternalBankAccountDataInstitution",
      "SaltEdgeExternalBankAccountDataInstitution",
      "SissExternalBankAccountDataInstitution",
      "SkriptExternalBankAccountDataInstitution",
      "StripeExternalBankAccountDataInstitution",
    ];
    FXHedge: ["ExternalFXHedge", "ManagedFXHedge"];
    FXProvider: ["CurrencycloudAccount", "EburyClient"];
    FXRateDataPoint: ["FXRateDataPointDate", "FXRateDataPointDateTime"];
    FXTrade: ["CurrencycloudFXTrade", "EburyFXTrade"];
    FXTradeQuote: ["FXTradeFirmQuote", "FXTradeQuoteEstimate"];
    FundMovement: ["Deposit", "EburyFXTrade", "Payout", "Transfer"];
    LedgerAccount: [
      "AssetLedgerAccount",
      "BeneficiaryLedgerAccount",
      "FXMarginProviderLedgerAccount",
      "OrganisationLedgerAccount",
    ];
    MacquarieImportTransactionOption: [
      "MacquarieImportTransactionAnnotationOption",
      "MacquarieImportTransactionNewDepositOption",
      "MacquarieImportTransactionPayoutOption",
      "MacquarieImportTransactionTransferNewOption",
      "MacquarieImportTransactionTransferOption",
    ];
    Node: [
      "ActivityStatement",
      "Address",
      "BalanceStatement",
      "BankAccountProduct",
      "BeneficiaryAccount",
      "BusinessEntity",
      "CurrencycloudFXTrade",
      "Deposit",
      "EburyAccount",
      "EburyBeneficiary",
      "EburyFXTrade",
      "Event",
      "ExternalBankAccountAsset",
      "ExternalFXHedge",
      "FXAsset",
      "FixedIncomeFundAsset",
      "FundProduct",
      "LedgerTransaction",
      "MacquarieTransactionImportFile",
      "ManagedFXHedge",
      "MonthlyStatement",
      "NoticeAccountAsset",
      "Organisation",
      "PaymentInstructionFile",
      "Payout",
      "SavingsAsset",
      "StatementBatch",
      "TermDepositAsset",
      "TermDepositProduct",
      "Transaction",
      "Transfer",
      "TransferGroup",
      "UnknownEventObject",
      "UsRIARecord",
      "UserProfile",
    ];
    PaymentIdentifier: [
      "AuBsbPaymentIdentifier",
      "AuPayIdPaymentIdentifier",
      "AuUnitFundPaymentIdentifier",
      "IbanPaymentIdentifier",
      "SwiftBicPaymentIdentifier",
      "SwiftPaymentIdentifier",
      "UsAbaPaymentIdentifier",
    ];
    Product: ["BankAccountProduct", "FundProduct", "TermDepositProduct"];
    Statement: ["ActivityStatement", "BalanceStatement", "MonthlyStatement"];
    TermDepositMaturityInstructions: [
      "TermDepositMaturityInstructionsRollover",
      "TermDepositMaturityInstructionsRolloverPrinciple",
      "TermDepositMaturityInstructionsTransfer",
    ];
    TimeLogUpdate: [
      "BaseTimeLogUpdate",
      "FXTradeTimeLogUpdate",
      "PayoutTimeLogUpdate",
    ];
    TransferUnit: ["TransferUnitCurrency", "TransferUnitFund"];
    UpcomingPolicyTransaction: ["Payout", "Transfer"];
    UserTask: [
      "AlertRuleUserTask",
      "ApprovalRequestUserTask",
      "ExternalAccountRelinkingUserTask",
      "FXFundingUserTask",
      "GroupedExternalAccountRelinkingUserTask",
      "ManageAllocationsUserTask",
    ];
  };
};
const result: PossibleTypesResultData = {
  possibleTypes: {
    Account: [
      "AkahuExternalAccountDetails",
      "BeneficiaryAccount",
      "ExternalBankAccountAsset",
      "FXAsset",
      "FixedIncomeFundAsset",
      "MercuryExternalAccountDetails",
      "NoticeAccountAsset",
      "QuilttExternalAccountDetails",
      "SaltEdgeExternalAccountDetails",
      "SavingsAsset",
      "SissExternalAccountDetails",
      "SkriptExternalAccountDetails",
      "StripeExternalAccountDetails",
      "TermDepositAsset",
    ],
    AccountsSummaryGroup: [
      "AccountTypeAccountsSummaryGroup",
      "AssetClassAccountsSummaryGroup",
      "BusinessEntityAccountsSummaryGroup",
      "CurrencyAccountsSummaryGroup",
      "ProviderAccountsSummaryGroup",
    ],
    ApprovalTarget: ["Payout", "Transfer"],
    Asset: [
      "ExternalBankAccountAsset",
      "FXAsset",
      "FixedIncomeFundAsset",
      "NoticeAccountAsset",
      "SavingsAsset",
      "TermDepositAsset",
    ],
    AssetRule: [
      "AlertAssetRule",
      "RecurringWithdrawalAssetRule",
      "TopUpAssetRule",
    ],
    BatchUpdateAssetResult: [
      "BatchUpdateAssetErrorResult",
      "BatchUpdateAssetSuccessResult",
    ],
    EburyTradeDetails: [
      "EburyFixedForwardDetails",
      "EburySpotTradeDetails",
      "EburyWindowForwardDetails",
    ],
    EventActor: [
      "EventActorExternalSystem",
      "EventActorExternalUser",
      "EventActorInternalUser",
      "EventActorScheduledJob",
      "EventActorStandaloneJob",
    ],
    ExternalAccountDetails: [
      "AkahuExternalAccountDetails",
      "MercuryExternalAccountDetails",
      "QuilttExternalAccountDetails",
      "SaltEdgeExternalAccountDetails",
      "SissExternalAccountDetails",
      "SkriptExternalAccountDetails",
      "StripeExternalAccountDetails",
    ],
    ExternalBankAccountDataInstitution: [
      "AkahuExternalBankAccountDataInstitution",
      "MercuryExternalBankAccountDataInstitution",
      "QuilttExternalBankAccountDataInstitution",
      "SaltEdgeExternalBankAccountDataInstitution",
      "SissExternalBankAccountDataInstitution",
      "SkriptExternalBankAccountDataInstitution",
      "StripeExternalBankAccountDataInstitution",
    ],
    FXHedge: ["ExternalFXHedge", "ManagedFXHedge"],
    FXProvider: ["CurrencycloudAccount", "EburyClient"],
    FXRateDataPoint: ["FXRateDataPointDate", "FXRateDataPointDateTime"],
    FXTrade: ["CurrencycloudFXTrade", "EburyFXTrade"],
    FXTradeQuote: ["FXTradeFirmQuote", "FXTradeQuoteEstimate"],
    FundMovement: ["Deposit", "EburyFXTrade", "Payout", "Transfer"],
    LedgerAccount: [
      "AssetLedgerAccount",
      "BeneficiaryLedgerAccount",
      "FXMarginProviderLedgerAccount",
      "OrganisationLedgerAccount",
    ],
    MacquarieImportTransactionOption: [
      "MacquarieImportTransactionAnnotationOption",
      "MacquarieImportTransactionNewDepositOption",
      "MacquarieImportTransactionPayoutOption",
      "MacquarieImportTransactionTransferNewOption",
      "MacquarieImportTransactionTransferOption",
    ],
    Node: [
      "ActivityStatement",
      "Address",
      "BalanceStatement",
      "BankAccountProduct",
      "BeneficiaryAccount",
      "BusinessEntity",
      "CurrencycloudFXTrade",
      "Deposit",
      "EburyAccount",
      "EburyBeneficiary",
      "EburyFXTrade",
      "Event",
      "ExternalBankAccountAsset",
      "ExternalFXHedge",
      "FXAsset",
      "FixedIncomeFundAsset",
      "FundProduct",
      "LedgerTransaction",
      "MacquarieTransactionImportFile",
      "ManagedFXHedge",
      "MonthlyStatement",
      "NoticeAccountAsset",
      "Organisation",
      "PaymentInstructionFile",
      "Payout",
      "SavingsAsset",
      "StatementBatch",
      "TermDepositAsset",
      "TermDepositProduct",
      "Transaction",
      "Transfer",
      "TransferGroup",
      "UnknownEventObject",
      "UsRIARecord",
      "UserProfile",
    ],
    PaymentIdentifier: [
      "AuBsbPaymentIdentifier",
      "AuPayIdPaymentIdentifier",
      "AuUnitFundPaymentIdentifier",
      "IbanPaymentIdentifier",
      "SwiftBicPaymentIdentifier",
      "SwiftPaymentIdentifier",
      "UsAbaPaymentIdentifier",
    ],
    Product: ["BankAccountProduct", "FundProduct", "TermDepositProduct"],
    Statement: ["ActivityStatement", "BalanceStatement", "MonthlyStatement"],
    TermDepositMaturityInstructions: [
      "TermDepositMaturityInstructionsRollover",
      "TermDepositMaturityInstructionsRolloverPrinciple",
      "TermDepositMaturityInstructionsTransfer",
    ],
    TimeLogUpdate: [
      "BaseTimeLogUpdate",
      "FXTradeTimeLogUpdate",
      "PayoutTimeLogUpdate",
    ],
    TransferUnit: ["TransferUnitCurrency", "TransferUnitFund"],
    UpcomingPolicyTransaction: ["Payout", "Transfer"],
    UserTask: [
      "AlertRuleUserTask",
      "ApprovalRequestUserTask",
      "ExternalAccountRelinkingUserTask",
      "FXFundingUserTask",
      "GroupedExternalAccountRelinkingUserTask",
      "ManageAllocationsUserTask",
    ],
  },
};
export default result;
